import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "@-webkit-keyframes styles_flapDownTop__1BWl_ {\n  from {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg)\n  }\n\n  50%, to {\n    -webkit-transform: rotateX(90deg);\n            transform: rotateX(90deg)\n  }\n}\n\n@keyframes styles_flapDownTop__1BWl_ {\n  from {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg)\n  }\n\n  50%, to {\n    -webkit-transform: rotateX(90deg);\n            transform: rotateX(90deg)\n  }\n}\n\n@-webkit-keyframes styles_flapDownBottom___KC9f {\n  from, 50% {\n    -webkit-transform: rotateX(90deg);\n            transform: rotateX(90deg)\n  }\n\n  90% {\n    -webkit-transform: rotateX(20deg);\n            transform: rotateX(20deg)\n  }\n\n  80%, to {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg)\n  }\n}\n\n@keyframes styles_flapDownBottom___KC9f {\n  from, 50% {\n    -webkit-transform: rotateX(90deg);\n            transform: rotateX(90deg)\n  }\n\n  90% {\n    -webkit-transform: rotateX(20deg);\n            transform: rotateX(20deg)\n  }\n\n  80%, to {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg)\n  }\n}\n\n.styles_digit__3_I6o {\n  color: white;\n  background-color: black;\n  position: relative;\n  display: inline-block;\n  box-sizing: content-box;\n  width: 1.1ch;\n  height: 1em;\n  font-family: sans-serif;\n  line-height: 1em;\n  text-align: center\n}\n\n.styles_digit__3_I6o[data-mode=\"words\"] {\n    width: 100%;\n  }\n\n.styles_digit__3_I6o[data-mode=\"alpha\"] {\n    width: 1.7ch;\n  }\n\n.styles_hinge__2iwrZ {\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  z-index: 3;\n  box-sizing: border-box;\n  height: 0.04em;\n  background-color: inherit;\n}\n\n.styles_flap__1tzQn {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  -webkit-animation-fill-mode: forwards;\n          animation-fill-mode: forwards;\n  -webkit-transform-origin: center;\n          transform-origin: center;\n  background-color: inherit;\n  background: inherit;\n  z-index: 1;\n  border-radius: inherit;\n  box-sizing: border-box\n}\n\n.styles_flap__1tzQn.styles_animated__eXIXQ {\n    -webkit-animation-duration: 300ms;\n            animation-duration: 300ms;\n    z-index: 2;\n  }\n\n.styles_flap__1tzQn.styles_top__1as09 {\n    -webkit-clip-path: polygon(0 50%, 100% 50%, 100% 0, 0 0);\n            clip-path: polygon(0 50%, 100% 50%, 100% 0, 0 0)\n  }\n\n.styles_flap__1tzQn.styles_top__1as09.styles_animated__eXIXQ {\n      -webkit-transform: rotateX(50deg);\n              transform: rotateX(50deg);\n      opacity: 0.40;\n    }\n\n.styles_flap__1tzQn.styles_top__1as09.styles_animated__eXIXQ.styles_final__1af3r {\n      opacity: 1;\n      -webkit-animation-name: styles_flapDownTop__1BWl_;\n              animation-name: styles_flapDownTop__1BWl_;\n      -webkit-animation-timing-function: ease-in;\n              animation-timing-function: ease-in;\n    }\n\n.styles_flap__1tzQn.styles_bottom__1CYW9 {\n    -webkit-clip-path: polygon(0 100%, 100% 100%, 100% 50%, 0 50%);\n            clip-path: polygon(0 100%, 100% 100%, 100% 50%, 0 50%)\n  }\n\n.styles_flap__1tzQn.styles_bottom__1CYW9.styles_animated__eXIXQ.styles_final__1af3r {\n      -webkit-animation-name: styles_flapDownBottom___KC9f;\n              animation-name: styles_flapDownBottom___KC9f;\n      -webkit-animation-timing-function: ease-out;\n              animation-timing-function: ease-out;\n    }\n";
var styles = { "digit": "styles_digit__3_I6o", "hinge": "styles_hinge__2iwrZ", "flap": "styles_flap__1tzQn", "animated": "styles_animated__eXIXQ", "top": "styles_top__1as09", "final": "styles_final__1af3r", "flapDownTop": "styles_flapDownTop__1BWl_", "bottom": "styles_bottom__1CYW9", "flapDownBottom": "styles_flapDownBottom___KC9f" };
styleInject(css);

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Flap = function Flap(_ref) {
  var _classnames;

  var above = _ref.above,
      bottom = _ref.bottom,
      animated = _ref.animated,
      final = _ref.final,
      hinge = _ref.hinge,
      children = _ref.children;

  var classes = classnames(styles.flap, (_classnames = {}, defineProperty(_classnames, styles.bottom, bottom), defineProperty(_classnames, styles.top, !bottom), defineProperty(_classnames, styles.animated, animated), defineProperty(_classnames, styles.final, final), _classnames));
  return React.createElement(
    'div',
    { className: classes },
    children,
    hinge && React.createElement('div', { className: styles.hinge, 'data-kind': 'hinge' })
  );
};

Flap.defaultProps = {
  above: false,
  bottom: false,
  animated: false,
  final: false
};

Flap.propTypes = {
  above: PropTypes.bool,
  bottom: PropTypes.bool,
  animated: PropTypes.bool,
  final: PropTypes.bool
};

var FlapDigit = function FlapDigit(_ref) {
  var className = _ref.className,
      css = _ref.css,
      value = _ref.value,
      prevValue = _ref.prevValue,
      final = _ref.final,
      mode = _ref.mode,
      restProps = objectWithoutProperties(_ref, ['className', 'css', 'value', 'prevValue', 'final', 'mode']);

  return React.createElement(
    'div',
    { className: styles.digit, 'data-kind': 'digit', 'data-mode': mode },
    React.createElement(
      Flap,
      restProps,
      value
    ),
    React.createElement(
      Flap,
      _extends({ bottom: true }, restProps),
      prevValue
    ),
    React.createElement(
      Flap,
      _extends({ key: 'top-' + prevValue, animated: true, final: final }, restProps),
      prevValue
    ),
    final && React.createElement(
      Flap,
      _extends({ key: 'bottom-' + value, bottom: true, animated: true, final: true }, restProps),
      value
    )
  );
};
FlapDigit.defaultProps = {
  value: '',
  prevValue: '',
  final: false,
  mode: null
};

FlapDigit.propTypes = {
  mode: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  prevValue: PropTypes.string,
  final: PropTypes.bool
};

// Set these three values as one state var
// to avoid in-between render states
var InitialCursor = {
  current: -1,
  previous: -1,
  target: 0
};

var FlapStack = function FlapStack(_ref) {
  var stack = _ref.stack,
      value = _ref.value,
      timing = _ref.timing,
      restProps = objectWithoutProperties(_ref, ['stack', 'value', 'timing']);

  var _useState = useState(InitialCursor),
      _useState2 = slicedToArray(_useState, 2),
      cursor = _useState2[0],
      setCursor = _useState2[1];

  useEffect(function () {
    setCursor(InitialCursor);
  }, [stack]);

  useEffect(function () {
    var current = cursor.current,
        previous = cursor.previous;

    var target = Math.max(stack.indexOf(value), 0);

    var increment = function increment() {
      previous = current;
      if (current >= stack.length - 1) {
        current = 0;
      } else {
        current = current + 1;
      }

      setCursor({
        current: current,
        previous: previous,
        target: target
      });
    };

    increment();

    var timer = setInterval(function () {
      if (current === target) {
        clearInterval(timer);
      } else {
        increment();
      }
    }, timing);

    return function () {
      return clearInterval(timer);
    };
  }, [stack, value]);

  var current = cursor.current,
      previous = cursor.previous,
      target = cursor.target;

  return React.createElement(FlapDigit, _extends({
    value: stack[current],
    prevValue: stack[previous],
    final: current === target
  }, restProps));
};
FlapStack.propTypes = {
  stack: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  timing: PropTypes.number.isRequired
};

var Presets = {
  NUM: ' 0123456789',
  ALPHANUM: ' 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
};

var Modes = {
  Numeric: 'num',
  Alphanumeric: 'alpha',
  Words: 'words'
};

var splitChars = function splitChars(v) {
  return String(v).split('').map(function (c) {
    return c.toUpperCase();
  });
};

var padValue = function padValue(v, length, padChar, padStart) {
  var trimmed = v.slice(0, length);
  return padStart ? String(trimmed).padStart(length, padChar) : String(trimmed).padEnd(length, padChar);
};

var FlapDisplay = function FlapDisplay(_ref) {
  var id = _ref.id,
      className = _ref.className,
      css = _ref.css,
      value = _ref.value,
      chars = _ref.chars,
      words = _ref.words,
      length = _ref.length,
      padChar = _ref.padChar,
      padMode = _ref.padMode,
      render = _ref.render,
      restProps = objectWithoutProperties(_ref, ['id', 'className', 'css', 'value', 'chars', 'words', 'length', 'padChar', 'padMode', 'render']);

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      stack = _useState2[0],
      setStack = _useState2[1];

  var _useState3 = useState(Modes.Numeric),
      _useState4 = slicedToArray(_useState3, 2),
      mode = _useState4[0],
      setMode = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = slicedToArray(_useState5, 2),
      digits = _useState6[0],
      setDigits = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = slicedToArray(_useState7, 2),
      children = _useState8[0],
      setChildren = _useState8[1];

  useEffect(function () {
    if (words && words.length) {
      setStack(words);
      setMode(Modes.Words);
    } else {
      setStack(splitChars(chars));
      setMode(chars.match(/[a-z]/i) ? Modes.Alphanumeric : Modes.Numeric);
    }
  }, [chars, words]);

  useEffect(function () {
    if (words && words.length) {
      setDigits([value]);
    } else {
      var padStart = padMode === 'auto' ? !!value.match(/^[0-9]*$/) : padMode === 'start';
      setDigits(splitChars(padValue(value, length, padChar, padStart)));
    }
  }, [value, chars, words, length, padChar, padMode]);

  useEffect(function () {
    setChildren(digits.map(function (digit, i) {
      return React.createElement(FlapStack, _extends({
        key: i,
        stack: stack,
        value: digit,
        mode: mode
      }, restProps));
    }));
  }, [digits].concat(toConsumableArray(Object.values(restProps))));

  return React.createElement(
    'div',
    {
      id: id,
      className: className,
      css: css,
      'aria-hidden': 'true',
      'aria-label': value
    },
    render ? render(_extends({}, restProps, { children: children })) : children
  );
};
FlapDisplay.defaultProps = {
  chars: Presets.NUM,
  padChar: ' ',
  timing: 30,
  hinge: true,
  padMode: 'auto'
};

FlapDisplay.propTypes = {
  id: PropTypes.string,
  css: PropTypes.object,
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  chars: PropTypes.string,
  words: PropTypes.arrayOf(PropTypes.string),
  length: PropTypes.number,
  padChar: PropTypes.string,
  padMode: PropTypes.string,
  timing: PropTypes.number,
  hinge: PropTypes.bool
};

export { FlapDisplay, Presets };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 19
// module chunks = 0